import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class GenderActions extends Actions{
    static get target(){
        return 'genders'
    }
}


// WEBPACK FOOTER //
// ./actions/GenderActions.js